import React, { useEffect } from "react";
import { AppRouteURI, AppRoutingRoles } from "router/RoleBasedAccess";
import App from "../app/App";
import SettingsContainer from "./SettingsContainer";
import settingsActions from "./actions";
import { SettingsTabs } from "./constants";

export default function () {
  const { isProtected, checkRoles } = {
    ...AppRoutingRoles[AppRouteURI.SETTINGS],
  };
  const { setTab } = settingsActions();

  useEffect(() => {
    setTab(SettingsTabs.PROFILE);
  });
  return (
    <App
      isProtected={isProtected}
      checkRoles={checkRoles}
      showSidebar={true}
      adminHeader={true}
    >
      <SettingsContainer />
    </App>
  );
}
